<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="12" md="6" lg="3">
      <v-select
        v-model="receiver"
        @change="applyReceiverType"
        :label="$t('transfer.filter.receiverType')"
        :items="receiverType"
        item-value="value"
        item-text="name"
        clearable
        outlined
        dense
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="9">
      <v-card
        v-if="!receiver"
        color="grey lighten-3"
        elevation="0"
        class="pa-5"
      />

      <FilterAutocompleteObject
        v-show="receiver === 'HOST'"
        :label="$t('transfer.filter.host')"
        :loading="isSearchingHosts"
        :fetchData="fetchTransfers"
        :asyncSearch="fetchHostsBySearchText"
        :items="hostSearchResults"
        prepend-inner-icon="mdi-magnify"
        append-icon=""
        ref="filterHostName"
        type="hostIds"
        value="id"
        hide-no-data
        multiple
      />

      <FilterAutocompleteObject
        v-show="receiver === 'VENDOR'"
        :label="$t('transfer.filter.vendor')"
        :loading="isVendorLoading"
        :fetchData="fetchTransfers"
        :asyncSearch="searchVendors"
        :items="vendorSearchResults"
        prepend-inner-icon="mdi-magnify"
        append-icon=""
        ref="filterVendorName"
        type="vendorIds"
        value="id"
        hide-no-data
        multiple
      />

      <FilterAutocompleteObject
        v-show="receiver === 'PARTNER'"
        :label="$t('transfer.filter.partner')"
        :fetchData="fetchTransfers"
        :asyncSearch="fetchPartners"
        :items="partners"
        prepend-inner-icon="mdi-magnify"
        append-icon=""
        ref="filterPartnerName"
        type="partnerIds"
        value="id"
        hide-no-data
        multiple
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterDates
        :fetchData="fetchTransfers"
        :dateRange="true"
        :label="$t('transfer.filter.date')"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterAutocomplete
        :label="$t('transfer.filter.status')"
        :fetchData="fetchTransfers"
        :items="status"
        :multiple="true"
        type="status"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterAutocomplete
        :label="$t('transfer.filter.orderBy')"
        :fetchData="fetchTransfers"
        :items="orderBy"
        type="orderBy"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterSearch
        searchTerm="appointmentCode"
        :fetchData="fetchTransfers"
        label="appointmentCode"
      />
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="4">
      <FilterSearch
        searchTerm="total"
        :fetchData="fetchTransfers"
        label="totalValue"
        type="number"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { receiverType } from '@/util/enums'

import FilterDates from '@/components/filters/FilterDates'
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import FilterAutocompleteObject from '@/components/filters/FilterAutocompleteObject'
import FilterHost from '@/components/filters/FilterHost'
import HostSelect from '@/components/host/HostSelect'
import FilterSearch from '../filters/FilterSearch.vue'

export default {
  name: 'TransferListFilters',

  components: {
    FilterDates,
    FilterAutocomplete,
    FilterAutocompleteObject,
    FilterHost,
    HostSelect,
    FilterSearch
},

  computed: {
    ...mapGetters([
      'hostSearchResults',
      'isSearchingHosts',

      'vendorSearchResults',
      'isVendorLoading',

      'partners',
    ]),
  },

  methods: {
    ...mapActions([
      'fetchTransfers',
      'fetchHostsBySearchText',
      'searchVendors',
      'fetchPartners',
    ]),

    ...mapMutations(['setFilters']),

    applyReceiverType() {
      this.setFilters({
        receiverType: this.receiver,
        hostIds: null,
        vendorIds: null,
        partnerIds: null,
      })

      this.$nextTick(() => this.$parent.resetSelected())

      this.$nextTick(() => this.$refs.filterHostName.clearFilter())

      this.$nextTick(() => {
        this.$refs.filterHostName.clearInput()
        this.$refs.filterVendorName.clearInput()
        this.$refs.filterPartnerName.clearInput()
      })
    }
  },

  data() {
    return {
      receiverType,
      receiver: null,

      status: [
        { value: 'CANCELED', name: this.$t('transfer.transferStatus.CANCELED') },
        { value: 'FAILED', name: this.$t('transfer.transferStatus.FAILED') },
        { value: 'PENDING', name: this.$t('transfer.transferStatus.PENDING') },
        { value: 'PROCESSING', name: this.$t('transfer.transferStatus.PROCESSING') },
        { value: 'COMPLETED', name: this.$t('transfer.transferStatus.COMPLETED') },
        // { value: 'DETACHED', name: this.$t('transfer.transferStatus.DETACHED') },
      ],
      orderBy: [
        { value: 'ASC', name: this.$t('transfer.orderBy.ASC') },
        { value: 'DESC', name: this.$t('transfer.orderBy.DESC') },
      ]
    }
  },

  mounted() {
    this.fetchPartners()
  }
}
</script>
